import React, {useState} from 'react';
import RoomImagesSlider from "../components/RoomImagesSlider";
import FormSelection from "../components/modals/FormSelection";
import {Button} from "react-bootstrap"; // Убедись, что путь правильный
import {roomTypes} from "../components/helpers/roomTypes"

// Группируем номера по категориям
const groupedRoomTypes = Object.entries(roomTypes.reduce((acc, room) => {
    if (!acc[room.category]) {
        acc[room.category] = [];
    }
    acc[room.category].push(room);
    return acc;
}, {}));


const RoomsPage = () => {

    const [formSelectionVisible, setFormSelectionVisible] = useState(false);

    return (
        <div className="rooms-page-container">
            <header className="page-header">
                <h1>Номера Санатория "Узбекистан"</h1>
            </header>

            <div className="sections-wrapper">

                {groupedRoomTypes.map(([category, rooms], categoryIndex) => (
                    <section className="room-category-section" key={categoryIndex}>
                        <div className="room-list-alternating">
                            {rooms.map((room, roomIndex) => (
                                <div className={`room-card-alternating ${roomIndex % 2 !== 0 ? 'reverse' : ''}`} key={room.id}>

                                    <div className="room-image-slider-container-alt">
                                        {room.images && room.images.length > 0 ? (
                                            <RoomImagesSlider images={room.images} />
                                        ) : (
                                            <div className="no-images-placeholder-alt">Нет фото</div>
                                        )}
                                    </div>

                                    <div
                                        className="room-info-block-alt">
                                        <h3 className="room-title-alt">{room.title}</h3>
                                        <p className="room-description-alt">{room.description}</p>

                                        {room.features && room.features.length > 0 && (
                                            <div
                                                className="room-features-block-alt">
                                                <h4 className="features-title-alt">Особенности
                                                    номера:</h4>
                                                <ul className="room-features-list-alt">
                                                    {room.features.map((feature, featureIndex) => (
                                                        <li key={featureIndex}>{feature}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                        {room.price &&
                                            <div className="room-price-alt">
                                                <Button
                                                    variant="success"
                                                    className="room-details-button"
                                                    onClick={() => setFormSelectionVisible(true)}
                                                    size="sm"
                                                >
                                                    ПОДРОБНЕЕ
                                                </Button>
                                                {room.price}
                                            </div>
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                ))}
            </div>
            <FormSelection show={formSelectionVisible} onHide={() => setFormSelectionVisible(false)}/>
        </div>
    );
};

export default RoomsPage;